module.exports = __webpack_public_path__ + "img/abriss.7139d42d.png";